import { Controller } from "@hotwired/stimulus"
import { swipeableMixin } from "./mixins/swipeable"

/**
 * Ad Swipe Controller - iOS Mail-style swipe-to-delete for draft ads
 *
 * Uses shared swipeable mixin for touch handling.
 * Only activates for draft (deletable) ads.
 *
 * Usage:
 * <div data-controller="ad-swipe"
 *      data-ad-swipe-deletable-value="true"
 *      data-ad-swipe-threshold-value="50"
 *      data-ad-swipe-delete-width-value="80">
 *   <a data-ad-swipe-target="card">...</a>
 *   <div data-ad-swipe-target="deleteAction">...</div>
 * </div>
 */
export default class extends Controller {
  static targets = ["card", "deleteAction", "deleteButton"]
  static values = {
    adId: Number,
    deletable: Boolean,
    threshold: { type: Number, default: 50 },
    deleteWidth: { type: Number, default: 80 }
  }

  connect() {
    // Only activate for deletable (draft) ads
    if (!this.deletableValue) return

    swipeableMixin.setup(this)
  }

  disconnect() {
    if (this.deletableValue) {
      swipeableMixin.teardown(this)
    }
  }
}
